import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from 'jquery';

import Header from './header';
import FAQBookmarks from './faq_bookmarks';
import FAQSection from './faq_section';
import specialOffer from './specialoffer';
import blogDraggable from './blog_draggable';
import isSafari from './is_safari';

$(document).ready(() => {
    const header = new Header();
    const faqbookmarks = new FAQBookmarks();
    const faqsection = new FAQSection();
    const specialoffer = new specialOffer();
    const blogdraggable = new blogDraggable();
    const issafari = new isSafari();
    //Remove disabled button on forms
    $('.wpcf7-submit').removeAttr('disabled');
});
